const INFO = {
  COMPANY_NAME: "회사명",
  COMPANY_ADDRESS: "주소를 입력해 주세요",
  // COMPANY_EMAIL: "kakao: 1qwe1qwe",
  // COMPANY_PHONE: "010-6829-3003",
  COMPANY_EMAIL: "email@google.com",
  COMPANY_PHONE: "010-0000-0000",
  COMPANY_PAX: "031-000-0000",
  WORKING_TIME: "평일 오전 9시 ~ 오후 6시 / 토, 일, 공휴일 휴무",
  GOOGLE_LOCATION:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6330.876307001546!2d127.0227539947912!3d37.497582888225814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca15a2cc3f2a7%3A0xd2e44a2795272fca!2z6rCV64Ko7Jet!5e0!3m2!1sko!2skr!4v1693480982536!5m2!1sko!2skr",

  CEO_NAME: "대표 이름",
  BUSINESS_NO: "000-00-0000",

  THEME_COLOR: "#0b4b6f",
  THEME_COLOR_DARK: "#093c5d",
};

export default INFO;
